import React, { useCallback } from 'react';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { ANALYTICS_CHANNEL } from '../../../common/constants';
import { ErrorBoundaryUI } from '../../../common/ui/error-boundary-ui';
import createEventPayload from '../../../common/utils/analytics/analytics.codegen';
import { useExperience } from '../experience-tracker';
import { BaseErrorBoundary } from './error-boundary-base';
export var ErrorBoundary = function ErrorBoundary(_ref) {
  var children = _ref.children,
    errorComponent = _ref.errorComponent;
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  var experience = useExperience();
  var handleError = useCallback(function (error) {
    var _window;
    createAnalyticsEvent(createEventPayload('operational.linkCreate.unhandledErrorCaught', {
      browserInfo: ((_window = window) === null || _window === void 0 || (_window = _window.navigator) === null || _window === void 0 ? void 0 : _window.userAgent) || 'unknown',
      error: error.name,
      componentStack: 'unknown'
    })).fire(ANALYTICS_CHANNEL);

    // Track experience as failed for SLO
    experience === null || experience === void 0 || experience.failure(error);
  }, [createAnalyticsEvent, experience]);
  return /*#__PURE__*/React.createElement(BaseErrorBoundary, {
    onError: handleError,
    errorComponent: errorComponent !== null && errorComponent !== void 0 ? errorComponent : /*#__PURE__*/React.createElement(ErrorBoundaryUI, null)
  }, children);
};